import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from "@mui/icons-material/Dashboard";
// import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CopyrightIcon from '@mui/icons-material/Copyright';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import GroupIcon from '@mui/icons-material/Group';
import CategoryIcon from '@mui/icons-material/Category';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useAuth } from '../../context/authContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import logo from "../../assets/furniba_logo.png";
import "./index.css";
import { Tooltip } from '@mui/material';
export default function Navbar() {
  const [anchorAllEl, setAnchorAllEl] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorSideEl, setAnchorSideEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const { logoutAdmin, currentUser } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const title = pathname.slice(1).replace(/-/g, " ").toUpperCase();
  // console.log("===current location", pathname.slice(1).replace(/-/g, " ").toUpperCase());

  const isMenuOpen = Boolean(anchorEl);
  const isAllMenuOpen = Boolean(anchorAllEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isSidebarOpen = Boolean(anchorSideEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleAllMenuOpen = (event) => {
  //   setAnchorAllEl(event.currentTarget);
  // };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleAllMenuClose = () => {
    setAnchorAllEl(null);
  };

  const handleSidebarOpen = (e) => {
    setAnchorSideEl(e.currentTarget);
  };

  const handleSidebarClose = () => {
    setAnchorSideEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const sidebarId = 'sidebar-menu';
  const renderSidebar = (
    // <div className="sidebar-menu-main">
    <Menu className="sidebar-menu-main" 
    // style={{ display: isSidebarOpen? "flex": "none"}} 
      
        // className='sidebar-menu-main'
        anchorEl={anchorSideEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id={sidebarId}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isSidebarOpen}
        onClose={handleSidebarClose}
        // style={{
        //   marginTop: "2rem"
        // }}
      >
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="open drawer"
        // sx={{ ml: 1.7, mt: -4.3 }}
        style={{
          position: "absolute",
          top: 7,
          left: 23.5,
          color: "#1976d2"
        }}
        aria-controls={sidebarId}
        aria-haspopup="true"
        onClick={handleSidebarClose}
      >
        <MenuIcon />
      </IconButton>
      <div style={{display:"flex", justifyContent:"center", alignItems:"center", width:"50%", margin:"auto"}} >
        <img src={"/furniba_logo.png"} style={{width:"100%"}} alt="" />
      </div>
      <section className='section' 
        onMouseLeave={handleSidebarClose}>
        <Link to="/dashboard" className={`${pathname.includes("dashboard")? "active" : "inactive"}`}>
          <div>
            <DashboardIcon/>
            <p>Dashboard</p>
          </div>
        </Link>
        <Link to="/admins" className={`${pathname.includes("admin")? "active" : "inactive"}`}>
          <div>
            <AdminPanelSettingsIcon/>
            <p>Admins</p>
          </div>
        </Link>
        <Link to="/users" className={`${pathname.includes("user")? "active" : "inactive"}`}>
          <div>
            <GroupIcon/>
            <p>Users</p>
          </div>
        </Link>
        <Link to="/user-types" className={`${pathname.includes("user-ypes")? "active" : "inactive"}`}>
          <div>
            <GroupIcon/>
            <p>User Types</p>
          </div>
        </Link>
        <Link to="/product-categories-bars" className={`${pathname.includes("product-categories-bars")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Product Category Bars</p>
          </div>
        </Link>
        <Link to="/product-categories" className={`${pathname.includes("product-categor")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Product Categories</p>
          </div>
        </Link>
        <Link to="/product-sub-categories" className={`${pathname.includes("sub-categor")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Product Sub-Categories</p>
          </div>
        </Link>
        <Link to="/attributes" className={`${pathname.includes("attribute")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Attributes</p>
          </div>
        </Link>
        <Link to="/products" className={`${pathname === "/products" || pathname === "/add-product" || pathname === "/update-product" ? "active" : "inactive"}`}>
          <div>
            <ShoppingCartCheckoutIcon/>
            <p>Products</p>
          </div>
        </Link>
        <Link to="/reviews" className={`${pathname.includes("review")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Ratings & Review</p>
          </div>
        </Link>
        <Link to="/orders" className={`${pathname.includes("order")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Orders</p>
          </div>
        </Link>
        <Link to="/analytics" className={`${pathname.includes("analytic")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Analytics</p>
          </div>
        </Link>
        <Link to="/city" className={`${pathname.includes("city")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >City</p>
          </div>
        </Link>
        <Link to="/slider" className={`${pathname.includes("slider")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Sliders</p>
          </div>
        </Link>
        <Link to="/store" className={`${pathname.includes("store")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Stores</p>
          </div>
        </Link>
        <Link to="/blog" className={`${pathname.includes("blog")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Blog</p>
          </div>
        </Link>
        <Link to="/testimonials" className={`${pathname.includes("testimonial")? "active" : "inactive"}`}>
          <div>
            <CategoryIcon/>
            <p >Testimonials</p>
          </div>
        </Link>
      </section>
    </Menu>
  );

  const menuAllId = 'primary-menu';
  const renderAllMenu = (
      <Menu
        // className='sidebar-menu-main'
        anchorEl={anchorAllEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id={menuAllId}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isAllMenuOpen}
        onClose={handleAllMenuClose}
        style={{
          marginTop: "2rem"
        }}
      >
        <Link to="/admins" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleAllMenuClose}>Admins</MenuItem></Link>
        <Link to="/users" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleAllMenuClose}>Users</MenuItem></Link>
        <Link to="/brands" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleAllMenuClose}>Brands</MenuItem></Link>
        <Link to="/product-categories" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleAllMenuClose}>Product Categories</MenuItem></Link>
        <Link to="/product-sub-categories" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleAllMenuClose}>Product Sub Categories</MenuItem></Link>
        <Link to="/products" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleAllMenuClose}>Products</MenuItem></Link>
        <Link to="/reviews" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleAllMenuClose}>Reviews</MenuItem></Link>
      </Menu>
  );

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id={menuId}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isMenuOpen}
        onClose={handleMenuClose}
        style={{
          marginTop: "2rem"
        }}
      >
        <div>
          <Link to="/" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleMenuClose}>Dashboard</MenuItem></Link>
          <Link to="/my-account" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={handleMenuClose}>My Account</MenuItem></Link>
          <Link to="/login" style={{color: "#000000", textDecoration: "none"}}><MenuItem onClick={logoutAdmin}>Logout</MenuItem></Link>
        </div>
      </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={17} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem> */}
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }} >
      <AppBar>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            aria-controls={sidebarId}
            aria-haspopup="true"
            onClick={handleSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            aria-controls={menuAllId}
            aria-haspopup="true"
            onClick={handleAllMenuOpen}
          >
            <MenuIcon />
          </IconButton> */}
          <Tooltip title="Go Back"
            onClick={() =>
              window.history.back()
            }
          >
            <IconButton>
              <ArrowBackIcon className='text-[#ffffff]'/>
            </IconButton>
          </Tooltip>
          <Typography
            variant="h6"
            nowrap={"true"}
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            <Link style={{color: 'white', textDecoration: "none"}} to="/">Furniba</Link>
          </Typography>
          <Box
            variant="h6"
            nowrap={"true"}
            component="div"
            // sx={{ display: { xs: 'none', sm: 'block'} }}
            style={{ 
              cursor: "pointer",
              fontSize: "2rem",
              position: "relative",
              left: "40%",
              transform: "translate(-50%)"
            }}
          >
            <Link to={pathname}>{title}</Link>
          </Box>
          {/* <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search> */}
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {/* <IconButton size="large" aria-label="show 4 new mails" color="inherit">
              <Badge badgeContent={1} color="error">
                <MailIcon />
              </Badge>
            </IconButton>
            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
            >
              <Badge badgeContent={1} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton> */}
            <p className='flex items-center font-bold text-xl cursor-pointer' onClick={() => navigate("my-account")}>{`${currentUser?.first_name} ${currentUser?.last_name}`}</p>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderAllMenu}
      {renderMobileMenu}
      {renderMenu}
      {renderSidebar}
    </Box>
  );
}